module.exports = __webpack_public_path__ + "static/media/85x11no2.0788dc42.jpg";